import { render, staticRenderFns } from "./MetaMessageTemplatePopUp.vue?vue&type=template&id=67c76650"
import script from "./MetaMessageTemplatePopUp.vue?vue&type=script&lang=js"
export * from "./MetaMessageTemplatePopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports